
import React, {useState, useEffect } from 'react';
import './Contact.css';

const WHATSAPP_NUMBER = '9056800633';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    contactNumber: '',
    message: ''
  });
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [formError, setFormError] = useState('');

  const handleChange = (e) => {
    if (formError) {
      setFormError('');
    }

    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const name = formData.name.trim();
    const contactNumber = formData.contactNumber.trim();
    const message = formData.message.trim();

    if (!name || !contactNumber || !message) {
      setFormError('Please fill out Name, Contact Number, and Message before continuing.');
      return;
    }

    setIsRedirecting(true);

    const whatsappMessage = `Hi, I want to contact YANX Wear

Name: ${name}
Contact Number: ${contactNumber}
Message: ${message}`;

    const encodedMessage = encodeURIComponent(whatsappMessage);
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;

    window.open(whatsappUrl, '_blank');
    setIsRedirecting(false);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);
  

  return (
    <div className="contact-page">
      <div className="contact-hero">
        <div className="container">
          <h1 className="page-title">Get in Touch</h1>
          <p className="page-subtitle">We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>
        </div>
      </div>

      <div className="contact-content">
        <div className="container">
          <div className="contact-wrapper">
            <div className="contact-form-section">
              <h2 className="section-heading">Send us a Message</h2>
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Your full name"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="contactNumber">Contact Number *</label>
                  <input
                    type="tel"
                    id="contactNumber"
                    name="contactNumber"
                    value={formData.contactNumber}
                    onChange={handleChange}
                    required
                    placeholder="Your phone number"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    placeholder="Your message here..."
                  ></textarea>
                </div>

                {formError && (
                  <div className="form-error" role="alert">
                    {formError}
                  </div>
                )}

                <button type="submit" className="btn btn-submit" disabled={isRedirecting}>
                  {isRedirecting ? 'Redirecting...' : 'Send Message'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;

